import { z } from 'zod';

export type AssignmentCountBySession = z.output<typeof assignmentCountBySessionSchema>;
export type AssignmentCountBySessionDTO = z.input<typeof assignmentCountBySessionSchema>;

export const assignmentCountBySessionSchema = z.object({
  count: z.number(),
  sessionId: z.uuid(),
});
